<div>
	<div>
		<div class="d-flex justify-content-between align-items-center mb-2">
			@if (!isOrgView()) {
			<h3 class="card-title mb-0">Payment History</h3>
			} @else {
			<span></span>
			}
			<div class="d-flex align-items-center gap-2">
				@if (!isOrgView()) {
				<ms-sort-dropdown [sortOptions]="sortOptions" [(selectedSortOption)]="orderBy"
					(selectedSortOptionChange)="setSortOrder($event)"></ms-sort-dropdown>
				<!-- payments.read is the capability that gates resending, and members don't hold it, so the
				     permission check below is the whole gate — matching the per-row Resend Receipt. -->
				<button *ifHasPermission="{
						requiredPermissions: [PaymentPermissions.Read],
						userPermissionOnly: false
					}"
					type="button" class="btn btn-ms-secondary"
					[disabled]="selectedCount() === 0 || isBulkResendingReceipts()"
					(click)="resendSelectedReceipts()">
					@if (isBulkResendingReceipts()) {
					<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
					Sending...
					} @else {
					<fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9" class="me-2" />Resend Receipts
					}
				</button>
				}
			</div>
		</div>

		<div class="d-flex justify-content-between align-items-center">
			<div class="mb-0 text-start flex-grow-0" #jumpToElementMobile>
				Showing: {{paymentHistoryList().length}} of {{totalCount | number}}
				<span class="badge bg-primary ms-0 ms-sm-2">
					Selected: {{selectedCount() | number}}
				</span>
			</div>
			<div class="text-end d-block d-sm-none" *ifHasPermission="{
					requiredPermissions: [PaymentPermissions.Read],
					userPermissionOnly: false
				}">
				<button id="toggleAllMobile" type="button" class="btn btn-ms-secondary text-start"
					(click)="toggleSelectAll()">
					<fa-duotone-icon icon="square-check" secondaryOpacity="0.2" size="lg" [hidden]="!isSelectAll" />
					<fa-duotone-icon icon="square" secondaryOpacity="0.2" size="lg" [hidden]="isSelectAll" />
					{{ (isSelectAll) ? 'Deselect All' : 'Select All' }}
				</button>
			</div>
		</div>

		<!-- Table Start -->
		<div class="table-responsive d-none d-sm-block">
			<table msResponsiveTable class="table table-hover fixed-header placeholder-glow">
				<thead #jumpToElement>
					<tr>
						<th msResponsiveTableColumn="checkbox" [priority]="1" scope="col" *ifHasPermission="{
								requiredPermissions: [PaymentPermissions.Read],
								userPermissionOnly: false
							}">
							<input id="toggleAllSelection" name="toggleAllSelection" type="checkbox"
								class="form-check-input fs-6" [checked]="isSelectAll"
								(change)="toggleSelectAll()" />
						</th>
						<th msResponsiveTableColumn="invoiceName" [priority]="1" scope="col">
							Invoice Name
						</th>
						@if (showsAllColumns()) {
						<th msResponsiveTableColumn="property" [priority]="4" scope="col">
							Property
						</th>
						}
						<th msResponsiveTableColumn="invoiceNumber" [priority]="1" scope="col">
							Invoice #
						</th>
						<th msResponsiveTableColumn="dateDue" [priority]="showsAllColumns() ? 7 : 4" scope="col"
							class="sortable" (click)="toggleSortDirection('Due Date')">
							Due Date
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy == PaymentHistoryListSortOptions.DueDateAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy == PaymentHistoryListSortOptions.DueDateDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="datePaid" [priority]="showsAllColumns() ? 3 : 1" scope="col"
							class="sortable" (click)="toggleSortDirection('Date Paid')">
							Date Paid
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy == PaymentHistoryListSortOptions.DatePaidAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy == PaymentHistoryListSortOptions.DatePaidDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="status" [priority]="showsAllColumns() ? 1 : 3" scope="col"
							class="sortable" (click)="toggleSortDirection('Status')">
							Status
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy == PaymentHistoryListSortOptions.StatusAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy == PaymentHistoryListSortOptions.StatusDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="amount" [priority]="2" scope="col" class="sortable numeric-column"
							(click)="toggleSortDirection('Amount')">
							Amount
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy == PaymentHistoryListSortOptions.AmountAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy == PaymentHistoryListSortOptions.AmountDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="fees" [priority]="5" scope="col" class="sortable numeric-column"
							(click)="toggleSortDirection('Fees')">
							Service Fees
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy == PaymentHistoryListSortOptions.FeesAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy == PaymentHistoryListSortOptions.FeesDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="paymentType" [priority]="6" scope="col">
							Payment Type
						</th>
						@if (showActionsColumn()) {
						<th msResponsiveTableColumn="actions" [priority]="1" class="fixed-header" scope="col">Actions
						</th>
						}
					</tr>
				</thead>
				<tbody>
					@for (payment of displayPayments; let i = $index; track getEffectivePaymentId(payment)) {
					<tr class="align-middle" [className]="(i % 2 === 0) ? 'even' : 'odd'">
						<td msResponsiveTableColumn="checkbox" [priority]="1" *ifHasPermission="{
								requiredPermissions: [PaymentPermissions.Read],
								userPermissionOnly: false
							}">
							<input type="checkbox" #toggleSelection class="form-check-input"
								[checked]="paymentIsSelected(payment)"
								(click)="paymentSelectionClicked(payment, toggleSelection.checked)" />
						</td>
						<td msResponsiveTableColumn="invoiceName" [priority]="1">
							<div class="d-flex align-items-center">
								@if (hasMultipleCharges(payment)) {
								<fa-duotone-icon [icon]="isExpanded(payment) ? 'minus' : 'plus'" secondaryOpacity="1"
									class="me-2 accordion-toggle flex-shrink-0" (click)="toggleAccordion(payment)" />
								}
								<span class="invoice-name-cell" [class.placeholder]="isLoading"
									[msTooltip]="getChargeNameDisplay(payment)" msTooltipOnlyIfTruncated>
									{{ getChargeNameDisplay(payment) | noValue }}
								</span>
							</div>
						</td>
						@if (showsAllColumns()) {
						<td msResponsiveTableColumn="property" [priority]="4">
							@if (hasMultipleProperties(payment)) {
							<span [class.placeholder]="isLoading">{{ getDistinctPropertyCount(payment) }} Properties</span>
							} @else {
							@let firstCharge = getFirstCharge(payment);
							<div class="property-info-stack">
								@if (firstCharge?.propertyTitle) {
								<span class="property-name d-block text-truncate"
										[msTooltip]="firstCharge!.propertyTitle ?? ''" msTooltipOnlyIfTruncated
									[class.placeholder]="isLoading">{{ firstCharge!.propertyTitle }}</span>
								}
								@if (firstCharge?.primaryAddress) {
								<small class="d-block text-muted lh-sm text-truncate"
									[msTooltip]="firstCharge!.primaryAddress ?? ''" msTooltipOnlyIfTruncated [class.placeholder]="isLoading">{{
									firstCharge!.primaryAddress }}</small>
								}
								@if (firstCharge?.lotNumber) {
								<small class="d-block text-muted lh-sm text-truncate"
									[msTooltip]="'Lot: ' + firstCharge!.lotNumber" msTooltipOnlyIfTruncated [class.placeholder]="isLoading">
									<span class="fw-medium">Lot:</span> {{ firstCharge!.lotNumber }}
								</small>
								}
							</div>
							}
						</td>
						}
						<td msResponsiveTableColumn="invoiceNumber" [priority]="1">
							<span [class.placeholder]="isLoading">{{ getInvoiceNumberDisplay(payment) | noValue
								}}</span>
						</td>
						<td msResponsiveTableColumn="dateDue" [priority]="showsAllColumns() ? 7 : 4">
							<span [class.placeholder]="isLoading">{{ getLatestDueDate(payment) | orgDate: 'shortDate' |
								noValue }}</span>
						</td>
						<td msResponsiveTableColumn="datePaid" [priority]="showsAllColumns() ? 3 : 1">
							<span [class.placeholder]="isLoading">{{ payment.paidDate | orgDate: 'shortDate' | noValue
								}}</span>
						</td>
						<td msResponsiveTableColumn="status" [priority]="showsAllColumns() ? 1 : 3">
							<ms-status-badge [status]="payment.status" [(isLoading)]="isLoading"></ms-status-badge>
						</td>
						<td msResponsiveTableColumn="amount" [priority]="2" class="numeric-column">
							<span [class.placeholder]="isLoading">{{ payment.amount | CurrencyDisplay: payment.currency
								| noValue }}</span>
						</td>
						<td msResponsiveTableColumn="fees" [priority]="5" class="numeric-column">
							<span [class.placeholder]="isLoading">{{ getDisplayFee(payment) | CurrencyDisplay:
								payment.currency | noValue }}</span>
						</td>
						<td msResponsiveTableColumn="paymentType" [priority]="6">
							<span [class.placeholder]="isLoading">{{ getPaymentMethodDisplay(payment) }}</span>
						</td>
						@if (showActionsColumn()) {
						<td msResponsiveTableColumn="actions" [priority]="1">
							@if (hasAnyRowAction(payment)) {
							<div class="dropdown" [msCloseMenuOnSettle]="isPaymentActionRunning(payment)">
								<button class="btn btn-sm btn-ms-secondary dropdown-toggle" data-bs-toggle="dropdown"
									[class.placeholder]="isLoading">
									Actions
								</button>
								<ul class="dropdown-menu dropdown-menu-end">
									<ng-container *ngTemplateOutlet="rowActions; context: { $implicit: payment }" />
								</ul>
							</div>
							} @else {
							<!-- A disabled button fires no hover or focus events, so the tooltip explaining why it is
							     dead has to sit on a wrapper the pointer and the tab order can still reach. Only this
							     branch carries it, so enabled rows don't each gain a redundant tab stop. -->
							<div class="dropdown" [msTooltip]="BalancesMessagingConstants.PAYMENT_NO_ROW_ACTIONS_TOOLTIP()">
								<button class="btn btn-sm btn-ms-secondary dropdown-toggle" disabled
									[class.placeholder]="isLoading">
									Actions
								</button>
							</div>
							}
						</td>
						}
					</tr>
					@if (isExpanded(payment) && payment.charges) {
					@for (charge of payment.charges; track charge.propertyChargeId) {
					<tr class="accordion-detail-row">
						<td msResponsiveTableColumn="checkbox" [priority]="1" *ifHasPermission="{
								requiredPermissions: [PaymentPermissions.Read],
								userPermissionOnly: false
							}"></td>
						<td msResponsiveTableColumn="invoiceName" [priority]="1" class="ps-4">
							<span class="text-muted">{{ charge.name | noValue }}</span>
						</td>
						@if (showsAllColumns()) {
						<td msResponsiveTableColumn="property" [priority]="4" class="ps-4">
							<div class="property-info-stack">
								@if (charge.propertyTitle) {
								<span class="property-name d-block text-truncate text-muted" [title]="charge.propertyTitle">{{ charge.propertyTitle }}</span>
								}
								@if (charge.primaryAddress) {
								<small class="d-block text-muted lh-sm text-truncate" [title]="charge.primaryAddress">{{ charge.primaryAddress }}</small>
								}
								@if (charge.lotNumber) {
								<small class="d-block text-muted lh-sm text-truncate" [title]="'Lot: ' + charge.lotNumber"><span class="fw-medium">Lot:</span> {{ charge.lotNumber }}</small>
								}
								</div>
							</td>
						}
						<td msResponsiveTableColumn="invoiceNumber" [priority]="1">
							<span class="text-muted">{{ charge.propertyChargeId }}</span>
						</td>
						<td msResponsiveTableColumn="dateDue" [priority]="showsAllColumns() ? 7 : 4">
							<span class="text-muted">{{ charge.dueDate | orgDate: 'shortDate' | noValue }}</span>
						</td>
						<td msResponsiveTableColumn="datePaid" [priority]="showsAllColumns() ? 3 : 1">{{ "" | noValue }}</td>
						<td msResponsiveTableColumn="status" [priority]="showsAllColumns() ? 1 : 3">{{ "" | noValue }}</td>
						<td msResponsiveTableColumn="amount" [priority]="2" class="numeric-column">
							<span class="text-muted">{{ charge.amount | CurrencyDisplay: payment.currency | noValue
								}}</span>
						</td>
						<td msResponsiveTableColumn="fees" [priority]="5" class="numeric-column">
							<span class="text-muted">{{ "" | noValue }}</span>
						</td>
						<td msResponsiveTableColumn="paymentType" [priority]="6">{{ "" | noValue }}</td>
						@if (showActionsColumn()) {
						<td msResponsiveTableColumn="actions" [priority]="1">{{ "" | noValue }}</td>
						}
					</tr>
					}
					}
					}
				</tbody>
				<tfoot class="overflow-auto" ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()"
					[(skip)]="skip" [hasNext]="hasNext" [itemCount]="displayPayments.length"
					(jumpToClicked)="jumpToTop($event)">
				</tfoot>
			</table>
		</div>
		<!-- Table End -->

		<!-- Mobile Cards Start -->
		<div id="mobileTableCards" class="d-block d-sm-none">
			@for (payment of displayPayments; let i = $index; track getEffectivePaymentId(payment)) {
			<div class="card d-flex pt-1 d-inline d-sm-none my-3"
				[msCloseMenuOnSettle]="isPaymentActionRunning(payment)">
				<div class="d-flex flex-column card-body">
					<div class="d-flex flex-row">
						<div class="card-left-column" *ifHasPermission="{
								requiredPermissions: [PaymentPermissions.Read],
								userPermissionOnly: false
							}">
							<ms-mobile-card-checkbox [itemId]="getEffectivePaymentId(payment)"
								[ariaLabel]="getSelectionAriaLabel(payment)"
								[isSelected]="paymentIsSelected(payment)"
								(clicked)="paymentSelectionClicked(payment, $event.checked)"
								[checkboxSize]="'md'" [checkboxShape]="'circle'" />
						</div>
						<div class="right-card-column w-100">
							<div class="mb-1" [class.accordion-clickable]="hasMultipleCharges(payment)"
								(click)="hasMultipleCharges(payment) && toggleAccordion(payment)">
								<h5 class="card-title mb-0 d-flex align-items-center min-width-0"
									[class.placeholder]="isLoading">
									@if (hasMultipleCharges(payment)) {
									<fa-duotone-icon [icon]="isExpanded(payment) ? 'minus' : 'plus'"
										secondaryOpacity="1" class="me-2 accordion-toggle flex-shrink-0" />
									}
									<span class="text-truncate" [msTooltip]="getChargeNameDisplay(payment)" msTooltipOnlyIfTruncated>
										{{ getChargeNameDisplay(payment) | noValue }}
									</span>
								</h5>
							</div>

							@if (showsAllColumns()) {
							<div class="card-text text-muted mb-2" [class.placeholder]="isLoading">
								@if (hasMultipleProperties(payment)) {
									{{ getDistinctPropertyCount(payment) }} Properties
									} @else {
									@let mobileFirstCharge = getFirstCharge(payment);
									<div class="property-info-stack">
										@if (mobileFirstCharge?.propertyTitle) {
										<span class="property-name d-block text-truncate" [title]="mobileFirstCharge!.propertyTitle">{{ mobileFirstCharge!.propertyTitle }}</span>
										}
										@if (mobileFirstCharge?.primaryAddress) {
										<small class="d-block lh-sm text-truncate" [title]="mobileFirstCharge!.primaryAddress">{{ mobileFirstCharge!.primaryAddress }}</small>
										}
										@if (mobileFirstCharge?.lotNumber) {
										<small class="d-block lh-sm text-truncate" [title]="'Lot: ' + mobileFirstCharge!.lotNumber"><span class="fw-medium">Lot:</span> {{ mobileFirstCharge!.lotNumber }}</small>
										}
									</div>
									}
							</div>
							}

							@if (!hasMultipleCharges(payment)) {
							<div class="card-text text-muted mb-2" [class.placeholder]="isLoading">
								Invoice #{{ getInvoiceNumberDisplay(payment) }}
							</div>
							}

							<div class="row g-2" [class.accordion-clickable]="hasMultipleCharges(payment)"
								(click)="hasMultipleCharges(payment) && toggleAccordion(payment)">
								@if (!hasMultipleCharges(payment)) {
								<div class="col-6 card-text" [class.placeholder]="isLoading">
									<div class="fw-semibold">Due Date</div>
									{{ getLatestDueDate(payment) | orgDate: 'shortDate' | noValue }}
								</div>
								<div class="col-6 card-text" [class.placeholder]="isLoading">
									<div class="fw-semibold">Date Paid</div>
									{{ payment.paidDate | orgDate: 'shortDate' | noValue }}
								</div>

								<div class="col-6 card-text" [class.placeholder]="isLoading">
									<div class="fw-semibold">Amount</div>
									{{ payment.amount | CurrencyDisplay: payment.currency | noValue }}
								</div>
								<div class="col-6 card-text" [class.placeholder]="isLoading">
									<div class="fw-semibold">Service Fees</div>
									{{ getDisplayFee(payment) | CurrencyDisplay: payment.currency | noValue }}
								</div>

								<div class="col-6 card-text" [class.placeholder]="isLoading">
									<div class="fw-semibold">Payment Type</div>
									{{ getPaymentMethodDisplay(payment) }}
								</div>
								<div class="col-6 d-flex align-items-end justify-content-end">
									<ms-status-badge [status]="payment.status"
										[(isLoading)]="isLoading"></ms-status-badge>
								</div>
								} @else {
								<div class="col-6 card-text" [class.placeholder]="isLoading">
									<div class="fw-semibold">Date Paid</div>
									{{ payment.paidDate | orgDate: 'shortDate' | noValue }}
								</div>
								<div class="col-6 card-text" [class.placeholder]="isLoading">
									<div class="fw-semibold">Payment Type</div>
									{{ getPaymentMethodDisplay(payment) }}
								</div>

								<div class="col-6 card-text" [class.placeholder]="isLoading">
									<div class="fw-semibold">Amount</div>
									{{ payment.amount | CurrencyDisplay: payment.currency | noValue }}
								</div>
								<div class="col-6 card-text" [class.placeholder]="isLoading">
									<div class="fw-semibold">Service Fees</div>
									{{ getDisplayFee(payment) | CurrencyDisplay: payment.currency | noValue }}
								</div>

								<div class="col-12 d-flex justify-content-end">
									<ms-status-badge [status]="payment.status"
										[(isLoading)]="isLoading"></ms-status-badge>
								</div>
								}
							</div>

							@if (isExpanded(payment) && payment.charges) {
							<hr class="my-3">
							<div class="fw-semibold mb-2 text-primary">Charges</div>
							@for (charge of payment.charges; track charge.propertyChargeId) {
							<div class="accordion-detail-card small mb-3 ps-2 border-start">
								<div class="row g-2 align-items-center">
									<div class="col-6 text-muted fw-semibold text-truncate"
										[msTooltip]="charge.name ?? ''" msTooltipOnlyIfTruncated>
										{{ charge.name | noValue }}
									</div>
									<div class="col-6 text-muted">
										<span class="fw-semibold">Due:</span>
										{{ charge.dueDate | orgDate: 'shortDate' | noValue }}
									</div>
								</div>
								<div class="text-muted mb-2">Invoice #{{ charge.propertyChargeId }}</div>
								<div class="row g-2">
									<div class="col-6 card-text text-muted">
										<div class="fw-semibold">Amount</div>
										{{ charge.amount | CurrencyDisplay: payment.currency | noValue }}
									</div>
									<div class="col-6 card-text text-muted">
										<div class="fw-semibold">Service Fees</div>
										{{ '' | noValue }}
									</div>
								</div>
							</div>
							}
							}
						</div>
					</div>
				</div>


				@if (hasAnyRowAction(payment)) {
				<button [attr.id]="'mobile-action-button-' + getEffectivePaymentId(payment)"
					class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown"
					[class.placeholder]="isLoading">
					Actions
				</button>
				<ul class="dropdown-menu dropdown-menu-end w-75">
					<ng-container *ngTemplateOutlet="rowActions; context: { $implicit: payment }" />
				</ul>
				}
			</div>
			}
			<div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
				[hasNext]="hasNext" [itemCount]="displayPayments.length" (jumpToClicked)="jumpToTop($event)">
			</div>
		</div>
		<!-- Mobile Cards End -->
	</div>
</div>

<!-- Row actions for the payment-history desktop and mobile dropdowns. Each item is hidden rather
     than greyed out when the viewer can't take it, so which items appear depends on the payment's
     status and on whether the viewer is an admin or a member — see the canShow* methods on the
     component. The menu is only built when at least one item survives (hasAnyRowAction); the desktop
     button itself still renders, disabled, so the reserved Actions column stays an unbroken run of
     buttons. Mobile cards drop the button instead — no column there to keep straight.
     The remaining [class.disabled] bindings are in-flight states, not permission states.
     (Resend Invoice lives on the invoice tables — see property-charge-list.) -->
<ng-template #rowActions let-payment>
	@if (canShowDownloadReceipt(payment)) {
	<li>
		<a class="dropdown-item" [class.disabled]="downloadingReceiptPaymentId() !== null" [attr.aria-disabled]="(downloadingReceiptPaymentId() !== null) ? true : null"
			msDebounceClick (msDebounceClick)="$event.stopPropagation(); downloadReceipt(payment)">
			@if (downloadingReceiptPaymentId() === getEffectivePaymentId(payment)) {
			<span class="spinner-border spinner-border-sm me-2" role="status"></span>Downloading...
			} @else {
			<fa-duotone-icon icon="file-pdf" secondaryOpacity="0.9" class="me-2" />Download Receipt
			}
		</a>
	</li>
	}
	@if (canShowResendReceipt(payment)) {
	<li>
		<a class="dropdown-item" [class.disabled]="resendingReceiptPaymentId() !== null" [attr.aria-disabled]="(resendingReceiptPaymentId() !== null) ? true : null"
			msDebounceClick (msDebounceClick)="$event.stopPropagation(); resendReceipt(payment)">
			@if (resendingReceiptPaymentId() === getEffectivePaymentId(payment)) {
			<span class="spinner-border spinner-border-sm me-2" role="status"></span>Sending...
			} @else {
			<fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9" class="me-2" />Resend Receipt
			}
		</a>
	</li>
	}
	@if (canShowUnmarkPayment(payment)) {
	@if (hasReceiptActions(payment)) {
	<li>
		<hr class="dropdown-divider">
	</li>
	}
	<li>
		<a class="dropdown-item" msDebounceClick (msDebounceClick)="openUnmarkModal(payment)">
			<fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />{{ isOrgView() ? 'Unmark Payment' :
			'Unmark Manual Payment' }}
		</a>
	</li>
	}
	@if (canShowDownloadRefundStatement(payment)) {
	<li>
		<a class="dropdown-item" [class.disabled]="downloadingStatementPaymentId() !== null" [attr.aria-disabled]="(downloadingStatementPaymentId() !== null) ? true : null"
			msDebounceClick (msDebounceClick)="$event.stopPropagation(); downloadRefundStatement(payment)">
			@if (downloadingStatementPaymentId() === payment.paymentId) {
			<span class="spinner-border spinner-border-sm me-2" role="status"></span>Downloading...
			} @else {
			<fa-duotone-icon icon="file-pdf" secondaryOpacity="0.9" class="me-2" />Download Refund Statement
			}
		</a>
	</li>
	}
	@if (canShowResendRefundStatement(payment)) {
	<li>
		<a class="dropdown-item" [class.disabled]="!payment.paymentId || resendingRefundStatementPaymentId() !== null" [attr.aria-disabled]="(!payment.paymentId || resendingRefundStatementPaymentId() !== null) ? true : null"
			msDebounceClick
			(msDebounceClick)="$event.stopPropagation(); resendRefundStatement(payment)">
			@if (resendingRefundStatementPaymentId() === payment.paymentId) {
			<span class="spinner-border spinner-border-sm me-2" role="status"></span>Sending...
			} @else {
			<fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9" class="me-2" />Resend Refund Statement
			}
		</a>
	</li>
	}
	@if (canShowCancelRefund(payment)) {
	@if (hasReceiptActions(payment)) {
	<li>
		<hr class="dropdown-divider">
	</li>
	}
	<li>
		<a class="dropdown-item" msDebounceClick (msDebounceClick)="openCancelRefundModal(payment)">
			<fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Cancel Refund
		</a>
	</li>
	}
	@if (canShowCancelPayment(payment)) {
	@if (hasReceiptActions(payment)) {
	<li>
		<hr class="dropdown-divider">
	</li>
	}
	<li>
		<button type="button" class="dropdown-item" [disabled]="cancelingPaymentId() !== null"
			msDebounceClick (msDebounceClick)="openCancelPaymentModal(payment)">
			@if (cancelingPaymentId() === payment.paymentId) {
			<span class="spinner-border spinner-border-sm me-2" role="status"></span>Canceling...
			} @else {
			<fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Cancel Payment
			}
		</button>
	</li>
	}
	@if (canShowRefundPayment(payment)) {
	@if (hasReceiptActions(payment)) {
	<li>
		<hr class="dropdown-divider">
	</li>
	}
	<li>
		<a class="dropdown-item" msDebounceClick (msDebounceClick)="openRefundModal(payment)">
			<fa-duotone-icon icon="rotate-left" secondaryOpacity="0.9" class="me-2" />Refund Payment
		</a>
	</li>
	}
</ng-template>

<ms-info-modal #resendInfoModalRef [modalId]="'paymentResendInfoModal'" />
<ms-unmark-payment-modal #unmarkPaymentModalRef (unmarkCompleted)="onUnmarkCompleted()" />
<ms-refund-payment-modal #refundPaymentModalRef (refundCompleted)="onRefundCompleted()" />
<ms-cancel-refund-modal #cancelRefundModalRef (cancelCompleted)="onCancelRefundCompleted()" />

<!-- Bulk Resend Receipts Confirmation Modal -->
<ms-confirmation-modal #bulkResendReceiptsConfirmationModalRef
	[modalId]="'bulkResendReceiptsConfirmationModal'"
	(confirmed)="onBulkResendReceiptsConfirmed()"
	(cancelled)="onBulkResendReceiptsCancelled()" />

<!-- Bulk Resend Receipts Info Modal -->
<ms-info-modal #bulkResendReceiptsInfoModalRef
	[modalId]="'bulkResendReceiptsInfoModal'" />

<!-- Cancel Payment Confirmation Modal (Pending ACH only; success/failure reuses #resendInfoModalRef above) -->
<ms-confirmation-modal #cancelPaymentConfirmationModalRef
	[modalId]="'cancelPaymentConfirmationModal'"
	(confirmed)="onCancelPaymentConfirmed()"
	(cancelled)="onCancelPaymentCancelled()" />
